export const FEATURES = {
  calendarEvents: 'view_events',
  trays: 'view_public_trays',
  courses: 'view_courses',
  fullAcademicYear: 'view_full_academic_year',
};
